import React, { useEffect, useMemo, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { getProducts } from "../lib/api";
import { ProductCard } from "../components/ProductCard";

const FILTERS = [
  { key: "all", label: "All Pieces" },
  { key: "lounge", label: "Lounge" },
  { key: "active", label: "Active" },
];

export default function Shop() {
  const [params, setParams] = useSearchParams();
  const category = params.get("category") || "all";
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    getProducts(category)
      .then((d) => setProducts(d))
      .finally(() => setLoading(false));
  }, [category]);

  const heading = useMemo(() => {
    if (category === "lounge") return "Lounge";
    if (category === "active") return "Active";
    return "The Collection";
  }, [category]);

  return (
    <div className="max-w-[1440px] mx-auto px-5 sm:px-6 lg:px-12 py-12 sm:py-16" data-testid="shop-page">
      <div className="grid grid-cols-12 gap-6 mb-10 sm:mb-14 items-end">
        <div className="col-span-12 lg:col-span-7 fade-up">
          <div className="micro-label text-[#1a1814]/60 mb-3 sm:mb-4">Shop · Spring Atelier</div>
          <h1 className="font-display text-5xl sm:text-7xl text-[#1a1814] leading-[0.95]">{heading}</h1>
        </div>
        <div className="col-span-12 lg:col-span-5 flex gap-2 lg:justify-end flex-wrap fade-up fade-up-1">
          {FILTERS.map((f) => {
            const active = category === f.key;
            return (
              <button
                key={f.key}
                type="button"
                onClick={() => setParams(f.key === "all" ? {} : { category: f.key })}
                className={`micro-label px-4 sm:px-5 py-2 border ${
                  active
                    ? "bg-[#1a1814] text-[#f0e9e1] border-[#1a1814]"
                    : "bg-transparent text-[#1a1814] border-[#1a1814]/20 hover:border-[#1a1814]"
                }`}
                data-testid={`shop-filter-${f.key}`}
              >
                {f.label}
              </button>
            );
          })}
        </div>
      </div>
      <div className="hairline mb-10 sm:mb-12" />

      {(() => {
        if (loading) {
          return <div className="py-32 text-center micro-label text-[#1a1814]/60">Loading the studio…</div>;
        }
        if (products.length === 0) {
          return <div className="py-32 text-center font-serif text-2xl">Nothing here yet. New pieces are on the way.</div>;
        }
        return (
          <div className="grid grid-cols-2 lg:grid-cols-3 gap-x-4 sm:gap-x-6 gap-y-10 sm:gap-y-14 lg:gap-x-10 lg:gap-y-20">
            {products.map((p, i) => (
              <ProductCard key={p.id} product={p} index={i} />
            ))}
          </div>
        );
      })()}
    </div>
  );
}
